import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-pointer': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M358.2 179.4c43.2-16.6 89.8 15.8 89.8 62.6v84c0 4.3-0.8 11.1-1.7 15.2l-27.4 119c-7 30.3-33.8 51.8-64.6 51.8h-178.3c-21.3 0-41.4-10.4-53.8-27.8l-109.7-154c-21.2-29.8-14.8-71.4 14.5-93.2 18.8-14 42.2-16.3 62.1-8.9v-161.1c0-36.9 29.7-67 66.3-67s66.3 30.1 66.3 67v73.6c20.4-2.9 41.5 3.9 56.6 19.6 27.2-12.8 60.4-5.7 79.9 19.1zM81 279.7c-14.4-20.2-43.8 2.4-29.4 22.6l109.7 154c3.4 4.8 8.9 7.7 14.7 7.7h178.3c8.5 0 15.8-6 17.8-14.6l27.4-119c0.3-1.4 0.5-2.9 0.5-4.4v-84c0-25.2-36.6-25.1-36.6 0 0 8.8-7.2 16-16 16h-6.9c-8.8 0-16-7.2-16-16v-21c0-25.2-36.6-25.1-36.6 0v21c0 8.8-7.2 16-16 16h-6.9c-8.8 0-16-7.2-16-16v-35c0-25.2-36.6-25.1-36.6 0v35c0 8.8-7.2 16-16 16h-6.9c-8.8 0-16-7.2-16-16v-175c0-25.2-36.6-25.1-36.6 0v241.5c0 15.6-20 21.9-29 9.3zM176.1 400v-96c0-8.8 6.3-16 14-16h6c7.7 0 14 7.2 14 16v96c0 8.8-6.3 16-14 16h-6c-7.7 0-14-7.2-14-16zM251.6 400v-96c0-8.8 6.3-16 14-16h6c7.7 0 14 7.2 14 16v96c0 8.8-6.3 16-14 16h-6c-7.7 0-14-7.2-14-16zM327 400v-96c0-8.8 6.3-16 14-16h6c7.7 0 14 7.2 14 16v96c0 8.8-6.3 16-14 16h-6c-7.7 0-14-7.2-14-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-pointer.js
// module id = 1770
// module chunks = 0